import React from "react";
import styles from '../assets/styles/form.module.scss'
export default function Footer() {
  const copyrightTxt = `Copyright © ${new Date().getFullYear()} ファーエンドテクノロジー株式会社`
  return (
    <footer>
      <p className={styles.copyright}>{copyrightTxt}</p>
    </footer>
  )
}